var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_19931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2742 14.8563C1.52354 14.8563 0.956218 14.6668 0.573895 14.287C0.191572 13.9073 0 13.3468 0 12.6058V2.25054C0 1.51434 0.191572 0.954728 0.573895 0.57332C0.956218 0.191107 1.52271 0 2.2742 0H5.46516V5.18811C5.46516 6.03881 5.89928 6.46457 6.7667 6.46457H12V12.6058C12 13.342 11.8084 13.9016 11.4261 14.2838C11.0438 14.666 10.4773 14.8571 9.7258 14.8571H2.2742V14.8563ZM6.89168 5.46227C6.62611 5.46227 6.49291 5.33164 6.49291 5.07118V0.0685404C6.65159 0.0870866 6.8111 0.150789 6.97225 0.260454C7.1334 0.370118 7.30031 0.512037 7.47215 0.686211L11.2921 4.48819C11.4738 4.67123 11.6193 4.84057 11.7295 4.99619C11.8389 5.15182 11.903 5.30745 11.9219 5.46307H6.89085L6.89168 5.46227Z",
    fill: "#248A3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_19931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 15,
    rx: 2.176,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocSuccess);
export default __webpack_public_path__ + "static/media/doc_success.4100129fb720f0ddb55fa310c313e4c1.svg";
export { ForwardRef as ReactComponent };